// Shared form validation and Quill syncing for Gestor create/edit forms
(function () {
    function bytesLength(str) {
        if (window.TextEncoder) return new TextEncoder().encode(str).length;
        try { return new Blob([str]).size; } catch (e) { return (str || '').length; }
    }

    function getQuillContent(form) {
        // Prefer the quill editor inside the current form
        const editor = form.querySelector('#quill-editor .ql-editor');
        if (editor) return editor.innerHTML;
        const textarea = form.querySelector('[name="cont_contenido"]');
        return textarea ? textarea.value : '';
    }

    function hasMeaningfulContent(html) {
        if (!html) return false;

        if (/(<(img|video|iframe|embed|object)\b)/i.test(html)) {
            return true;
        }

        const probe = document.createElement('div');
        probe.innerHTML = html;
        const plainText = (probe.textContent || probe.innerText || '')
            .replace(/\u00a0/g, '')
            .trim();

        return plainText.length > 0;
    }

    function clearFieldErrors(form) {
        form.querySelectorAll('.js-field-error').forEach(function (node) {
            node.remove();
        });
        form.querySelectorAll('.js-invalid-field').forEach(function (node) {
            node.classList.remove('js-invalid-field', 'border', 'border-danger', 'rounded');
        });
    }

    function resolveErrorTarget(form, field) {
        if (field === 'cont_contenido') {
            return form.querySelector('#quill-editor .ql-container') || form.querySelector('[name="cont_contenido"]');
        }
        if (field === 'cont_tags') {
            return form.querySelector('#cont_tags') || form.querySelector('[name="cont_tags[]"]');
        }
        return form.querySelector('[name="' + field + '"]');
    }

    function addFieldError(form, field, message) {
        const target = resolveErrorTarget(form, field);
        if (!target) return;

        target.classList.add('js-invalid-field', 'border', 'border-danger', 'rounded');

        const container = target.closest('.input-field, .form-group, .col-sm-12, .col-sm-6') || target.parentElement;
        if (!container) return;

        const error = document.createElement('span');
        error.className = 'helper-text red-text js-field-error d-block';
        error.textContent = message;
        container.appendChild(error);
    }

    function collectValidationErrors(form) {
        const maxTags = 10;
        const maxTitle = 255;
        const maxAuthor = 100;
        const maxTagLength = 50;
        const errors = {};

        const title = (form.querySelector('[name="cont_titulo"]')?.value || '').trim();
        const author = (form.querySelector('[name="cont_autor"]')?.value || '').trim();
        const content = getQuillContent(form);
        const selectedTags = Array.from(form.querySelectorAll('[name="cont_tags[]"] option:checked'))
            .map(function (opt) { return (opt.value || '').trim(); })
            .filter(Boolean);
        const tagsCount = selectedTags.length;

        if (title.length < 3) {
            errors.cont_titulo = 'El titulo debe tener al menos 3 caracteres.';
        } else if (title.length > maxTitle) {
            errors.cont_titulo = 'El titulo permite maximo 255 caracteres.';
        }

        if (author.length < 3) {
            errors.cont_autor = 'El autor debe tener al menos 3 caracteres.';
        } else if (author.length > maxAuthor) {
            errors.cont_autor = 'El autor permite maximo 100 caracteres.';
        }

        if (!hasMeaningfulContent(content)) {
            errors.cont_contenido = 'Agrega el contenido.';
        } else if (bytesLength(content) > 65000) {
            errors.cont_contenido = 'El contenido supera el limite de bytes permitido. Reduce imagenes o texto.';
        }

        if (tagsCount > maxTags) {
            errors.cont_tags = 'Solo puedes agregar maximo 10 etiquetas.';
        } else if (selectedTags.some(function (tag) { return tag.length > maxTagLength; })) {
            errors.cont_tags = 'Cada etiqueta permite maximo 50 caracteres.';
        }

        const textarea = form.querySelector('[name="cont_contenido"]');
        if (textarea) textarea.value = content;

        return errors;
    }

    function renderValidationErrors(form, errors) {
        clearFieldErrors(form);
        Object.keys(errors).forEach(function (field) {
            addFieldError(form, field, errors[field]);
        });

        const firstField = Object.keys(errors)[0];
        if (firstField) {
            const target = resolveErrorTarget(form, firstField);
            if (target && typeof target.scrollIntoView === 'function') {
                target.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
        }
    }

    function validateAndRender(form) {
        const errors = collectValidationErrors(form);
        renderValidationErrors(form, errors);
        return Object.keys(errors).length === 0;
    }

    document.addEventListener('DOMContentLoaded', function () {
        const forms = document.querySelectorAll('form');
        if (!forms.length) return;

        forms.forEach(function (form) {
            if (!form.querySelector('[name="cont_titulo"]') || !form.querySelector('[name="cont_contenido"]')) {
                return;
            }

            form.addEventListener('submit', function (e) {
                form.dataset.validationAttempted = '1';
                if (!validateAndRender(form)) {
                    e.preventDefault();
                }
            }, true);

            form.addEventListener('input', function () {
                if (form.dataset.validationAttempted === '1') {
                    validateAndRender(form);
                }
            });

            form.addEventListener('change', function () {
                if (form.dataset.validationAttempted === '1') {
                    validateAndRender(form);
                }
            });
        });
    });

    // Shared state for portada/temp file handling
    window.Gestor = window.Gestor || {};
    window.Gestor.formSubmitted = false;
    window.Gestor.lastTempFile = null;

    function getLegacyVar(name) {
        try {
            return window[name];
        } catch (e) {
            return undefined;
        }
    }

    function safeRoute(key, fallbackName) {
        return (window.Gestor && window.Gestor.routes && window.Gestor.routes[key]) || getLegacyVar(fallbackName) || '';
    }

    function initPortadaHandlers() {
        // Wait a bit for dropzone to initialize
        setTimeout(function () {
            var selector = ".gestor-dropzone[data-file_name='cont_portada']";
            var $dz = $(selector);
            if (!$dz.length) return;
            var portadaDropzone = $dz.data('dropzone-instance');
            if (!portadaDropzone) return;

            var originalUrl = (window.Gestor && window.Gestor.originalPortadaUrl)
                || (typeof window.GestorOriginalUrl !== 'undefined' ? window.GestorOriginalUrl : '');
            var originalName = (window.Gestor && window.Gestor.originalPortadaName)
                || (typeof window.GestorOriginalName !== 'undefined' ? window.GestorOriginalName : '');

            function showPreview(url, name) {
                $('#img-portada-preview').attr('src', url);
                $('#portada-preview-area').show();
                $('#portada-dropzone-area').hide();
                $('#img-portada-desc').text(name);
            }

            function showDropzone() {
                $('#portada-preview-area').hide();
                $('#portada-dropzone-area').show();
                $('#img-portada-preview').attr('src', '');
                $('#img-portada-desc').text('');
            }

            function deleteTempIfExists() {
                var last = window.Gestor.lastTempFile;
                var route = safeRoute('deleteTempImage', 'gestorDeleteTempImageRoute');
                var token = (window.Gestor && window.Gestor.csrfToken) || getLegacyVar('csrfToken');
                if (last) {
                    $.ajax({ url: route, method: 'POST', data: { filename: last, _token: token } });
                    window.Gestor.lastTempFile = null;
                }
            }

            portadaDropzone.on('success', function (file, response) {
                if (response && response.success && response.filename) {
                    var newUrl = '/storage/movilidad/contenidos/' + response.filename;
                    showPreview(newUrl, response.filename);
                    window.Gestor.lastTempFile = response.filename;
                }
            });

            portadaDropzone.on('removedfile', function () {
                if (originalUrl) {
                    showPreview(originalUrl, originalName);
                } else {
                    showDropzone();
                }
                deleteTempIfExists();
            });

            // Boton eliminar dentro del recuadro de preview
            $('#btn-portada-delete').on('click', function () {
                portadaDropzone.removeAllFiles(true);
                $("input[name='cont_portada']").val('');
                showDropzone();
                deleteTempIfExists();
                originalUrl = '';
                originalName = '';
            });

            window.addEventListener('beforeunload', function () {
                if (window.Gestor.lastTempFile && !window.Gestor.formSubmitted) {
                    var data = new FormData();
                    data.append('filename', window.Gestor.lastTempFile);
                    var token = (window.Gestor && window.Gestor.csrfToken) || getLegacyVar('csrfToken');
                    data.append('_token', token);
                    var route = safeRoute('deleteTempImage', 'gestorDeleteTempImageRoute');
                    try {
                        navigator.sendBeacon(route, data);
                        window.Gestor.lastTempFile = null;
                    } catch (ex) {
                        // ignore
                    }
                }
            });
        }, 300);
    }

    // Initialize portada handlers on DOM ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initPortadaHandlers);
    } else {
        initPortadaHandlers();
    }
})();
